import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c621bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

import { computed, type Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
},
  emits: ["update:modelValue", "search"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string): void;
  (e: 'search'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const value = computed({
  get() {
    return props.modelValue;
  },
  set(value: string) {
    emits('update:modelValue', value);
  },
});

const inputBar: Ref<HTMLElement | null> = ref(null);

function startSearch() {
  if (inputBar.value !== null) {
    inputBar.value.blur();
  }
  emits('search');
}

function enterPress(e: KeyboardEvent) {
  if (e.key === 'Enter') {
    startSearch();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      placeholder: "What are you looking for?",
      class: "search__bar",
      ref_key: "inputBar",
      ref: inputBar,
      type: "text",
      onKeypress: enterPress,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
      [_vModelText, _unref(value)]
    ]),
    _createElementVNode("button", {
      class: "btn search__btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (startSearch()))
    }, _hoisted_3)
  ]))
}
}

})